import { AfterViewInit, Component, OnInit, computed, signal, WritableSignal, OnDestroy, ChangeDetectorRef, effect, ViewChild, ElementRef } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { SelectedComponent } from "../../shared/selected/selected.component";
import { ListsService } from '../../services/lists.service';
import { LocationsComponent } from "../../shared/locations/locations.component";
import { ConfigInput, ConfigSelected } from '../../interfaces/interfaces';
import { InputComponent } from "../../shared/input/input.component";
import { IndependentComponent } from "../../shared/independent/independent.component";
import { AutomaticDebitComponent } from "../../shared/automatic-debit/automatic-debit.component";
import { AssociatedComponent } from "../../shared/associated/associated.component";
import { PensionersComponent } from "../../shared/pensioners/pensioners.component";
import { AgriculturalComponent } from "../../shared/agricultural/agricultural.component";
import { SecurityService } from '../../services/security.service';
import { Router } from '@angular/router';
import { ModalComponent } from "../../shared/modal/modal.component";
import { RouteService } from '../../services/route.service';
import { toast } from 'ngx-sonner';
import { HelpService } from '../../services/help.service';
import { WowComponent } from "app/shared/wow/wow.component";
import { ErrorScreenComponent } from "../../shared/error-screen/error-screen.component";
import ROUTES from '../../config/settings.config';
import { collapseConsecutiveSpaces, hasMinAddressLength } from '../../shared/utils/address-normalize.utils';

@Component({
  selector: 'app-address',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    SelectedComponent,
    LocationsComponent,
    InputComponent,
    IndependentComponent,
    AutomaticDebitComponent,
    AssociatedComponent,
    PensionersComponent,
    AgriculturalComponent,
    ModalComponent,
    WowComponent,
    ErrorScreenComponent,
],
  templateUrl: './address.component.html',
  styleUrl: './address.component.css'
})
export class AddressComponent implements OnInit, AfterViewInit, OnDestroy {
  form: FormGroup;
  resetTimer = signal(false);
  asotipId = signal(0);
  isValidAddress = signal(false);
  allowAddres = false;
  private lastProcessedAddress: string | null = null;
  private lastAddressValidation: 'CORRECTA' | 'INCORRECTA' | null = null;
  private inflightAddress: string | null = null;
  private inflightNormalization: Promise<any> | null = null;
  showQuotaModal = signal(false);
  defaultData: WritableSignal<any> = signal({});
  nextRoute: WritableSignal<string> = signal('');
  @ViewChild('address') addressInput!: ElementRef<HTMLInputElement>;
  isChecked = false;
  titleError: string = '';
  descriptionError: string = '';
  showAlert = signal(false);
  showError = signal(false);


  // Señal computada para validación reactiva
  isValidData = computed(() => {
    const data = this.defaultData();
    const asotip = this.asotipId();
    const formValid = this.form.valid;

    return this.validateAllData();
  });

  showWowSignal = signal(false);

  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: 'Dirección de Domicilio', subLabel: '', formName: 'address', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required, Validators.minLength(8), Validators.maxLength(55)], textError: 'Por favor escribe una dirección válida mayor a 8 y menor a 55 carácteres' },
    { label: 'Barrio Domicilio', subLabel: '', formName: 'neighborhood', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required, Validators.minLength(3), Validators.maxLength(30)], textError: 'Por favor ingresa un barrio mayor a 3 y mayor a 30 caracteres' },
  ]);

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
    { label: '¿Cuál es tu ocupación?', subLabel: '', formName: 'asotip', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([]) },
    { label: 'Zona en la que vives', subLabel: '', formName: 'zone', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona una zona', options: signal([{ value: 1, label: 'Rural' }, { value: 2, label: 'Urbana' }]) },
  ]);

  constructor(
    private _title: Title,
    private _loaderService: LoaderService,
    private _listService: ListsService,
    private _securityService: SecurityService,
    private _router: Router,
    private _routeService: RouteService,
    private _helpService: HelpService,

  ) {
    this._title.setTitle('Onboarding Digital | Datos extra');

    this.form = new FormGroup({
      asotip: new FormControl(null, Validators.required),
      location: new FormControl(null, Validators.required),
      address: new FormControl(null, Validators.required),
      neighborhood: new FormControl(null, Validators.required),
      zone: new FormControl(null, Validators.required),
    });

    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');

    this.form.get('asotip')?.valueChanges.subscribe((value: string | number) => {
      this.handleAsotipChange();
      this.asotipId.set(Number(value));
    });

    // Effects para debugging
    effect(() => {
      // console.log('defaultData cambió:', this.defaultData());
    });

    effect(() => {
      // console.log('currentData cambió:', this.currentData());
    });

    effect(() => {
      // console.log('isValidData computado:', this.isValidData());
    });
  }

  async ngOnInit() {
    const authRoute = localStorage.getItem('route');
    if (!authRoute) {
      this._router.navigateByUrl('');
      return;
    }

    const currentUrl = this._router.url;
    if (authRoute && currentUrl !== authRoute) {
      await this._router.navigateByUrl(authRoute);
      return;
    }

    const canStayOnAddress = await this.validateCheckpointForAddress();
    if (!canStayOnAddress) {
      return;
    }

    localStorage.removeItem('olimpiaPassed');
    sessionStorage.removeItem('olimpiaPassed');
    this._helpService.show();
    this.getAsotip();
  }

  ngAfterViewInit(): void {
    this.getDataAddress();
    this._loaderService.hide();
  }

  ngOnDestroy(): void {
  }

  private validateCheckpointForAddress(): Promise<boolean> {
    const addressRoute = ROUTES.find((route) => route.path === '/app/address');
    const addressStep = addressRoute?.step ?? 4;
    const addressCheckpoints = addressRoute?.checkpoint ?? [];

    return new Promise((resolve) => {
      this._securityService.getCheckpoint().subscribe({
        next: (response: any) => {
          const checkpoint = response?.checkpoint ?? '';

          if (checkpoint === 'LIST_ERROR_06') {
            this.failMessage('122: No es posible continuar con su vinculación por este canal. Por favor acérquese a una oficina o comuníquese con su asesor...');
            resolve(false);
            return;
          }

          const allowedRoute = [...ROUTES]
            .reverse()
            .find((route) => route.checkpoint.includes(checkpoint));

          const allowedStep = allowedRoute?.step ?? 0;
          const olimpiaPassed =
            localStorage.getItem('olimpiaPassed') === '1' ||
            sessionStorage.getItem('olimpiaPassed') === '1';
          const canAccessAddress =
            olimpiaPassed ||
            addressCheckpoints.includes(checkpoint) ||
            checkpoint === 'VALIDATE_DATA_04' ||
            allowedStep >= addressStep;

          if (canAccessAddress) {
            resolve(true);
            return;
          }

          this.failMessage('122: No es posible continuar con su vinculación por este canal. Por favor acérquese a una oficina o comuníquese con su asesor...');
          resolve(false);
        },
        error: (error: any) => {
          console.error(error);
          this._loaderService.hide();
          resolve(false);
        }
      });
    });
  }

  getDataAddress() {
    this._securityService.getAddressData()
    .subscribe({
      next: (response: any) => {
        if (response) {
          this.defaultData.set(response.addressData);
          this.asotipId.set(this.defaultData().asotip);
        //   if (response.addressData) {
        //     this.form.patchValue({
        //       asotip: response.addressData.asotip,
        //       location: response.addressData.location,
        //       address: response.addressData.address,
        //       neighborhood: response.addressData.neighborhood,
        //       zone: response.addressData.zone
        //     });
        // }
          this.dataInputs.update((inputs: any) =>
            inputs.map((input: any) => ({
              ...input,
              defaultValue: response.addressData[input.formName] ?? input.defaultValue
            }))
          );

          this.dataSelected.update((inputs: any) =>
            inputs.map((input: any) => ({
              ...input,
              defaultValue: response.addressData[input.formName] ?? input.defaultValue
            }))
          );

          setTimeout(() => {
          this.form.patchValue({
            location: response.addressData.location,
            address: response.addressData.address,
            neighborhood: response.addressData.neighborhood,
            zone: response.addressData.zone,
            asotip: response.addressData.asotip
          }, { emitEvent: false });
        });
        }
      },
      error: (error: any) => {
        console.error("ERROR: ", error);
      }
    });
  }

  getAsotip() {
    this._listService.getAsotip().subscribe({
      next: (response: any) => {
        this.dataSelected().at(0)?.options.set(response);
      },
      error: (error: any) => {
        console.error("ERROR: ", error);
      }
    });
  }

  setLocation(location: any) {
    if(this.defaultData().location != location){
      this.form.get('location')!.setValue(location);

      this.defaultData.update(currentData => ({
        ...currentData,
        location: location
      }));
    }
  }

  handleValue(event: { formName: string, value: string | number }) {
    if (event.formName === 'address') {
      this.onAddressBlur(String(event.value ?? ''));
      return;
    }

    this.form.get(event.formName)?.setValue(event.value);
    this.defaultData.update(currentData => ({
      ...currentData,
      [event.formName]: event.value
    }));
  }

  private patchAddressValue(value: string) {
    this.form.get('address')?.setValue(value, { emitEvent: false });
    this.defaultData.update((currentData) => ({
      ...currentData,
      address: value
    }));
    this.dataInputs.update((inputs) =>
      inputs.map((input) =>
        input.formName === 'address' ? { ...input, defaultValue: value } : input
      )
    );
  }

  private onAddressBlur(rawValue: string) {
    const normalized = collapseConsecutiveSpaces(rawValue);
    this.patchAddressValue(normalized);

    if (!hasMinAddressLength(normalized)) {
      this.lastProcessedAddress = null;
      this.lastAddressValidation = null;
      this.allowAddres = false;
      return;
    }

    if (this.lastProcessedAddress === normalized && this.lastAddressValidation) {
      return;
    }

    this.normalizeAddressWithIA(normalized);
  }

  private normalizeAddressWithIA(normalized: string): Promise<any> {
    if (this.inflightNormalization && this.inflightAddress === normalized) {
      return this.inflightNormalization;
    }

    this.inflightAddress = normalized;
    this.inflightNormalization = new Promise((resolve) => {
      this._securityService.checkAddress(normalized).subscribe({
        next: (response: any) => {
          if (response.cleared) {
            this.clearInvalidAddress();
            resolve(response);
            return;
          }

          if (response.tooShort) {
            this.lastProcessedAddress = null;
            this.lastAddressValidation = null;
            resolve(response);
            return;
          }

          this.lastProcessedAddress = normalized;
          this.lastAddressValidation = response.result ?? null;
          this.defaultData.update((currentData) => ({
            ...currentData,
            address: response.address ?? normalized,
            addressFixed: response.addressFixed
          }));
          resolve(response);
        },
        error: (error: any) => {
          console.error('Error normalizando dirección', error);
          toast.error('No se pudo validar la dirección. Intenta de nuevo.');
          resolve(null);
        }
      });
    }).finally(() => {
      if (this.inflightAddress === normalized) {
        this.inflightAddress = null;
        this.inflightNormalization = null;
      }
    });

    return this.inflightNormalization;
  }

  private clearInvalidAddress() {
    this.patchAddressValue('');
    this.lastProcessedAddress = null;
    this.lastAddressValidation = null;
    this.allowAddres = false;
    this.defaultData.update((currentData) => ({
      ...currentData,
      address: '',
      addressFixed: '',
      isAddressConfirmed: false
    }));
    toast.error('Por favor verifica la dirección. Escribela nuevamente.');
  }

  handleEvent(data: any) {
    console.log('Datos recibidos del hijo: ', data);
    if(this.defaultData().income !== data.income && data.income != '' && data.income != null){
      this._securityService.calculateQuota(data.income).subscribe({
        next: (response: any) => {
          this.showQuotaModal.set(true);
          this.defaultData.update(currentData => ({
            ...currentData,
            calculatedQuota: Number(response.data).toLocaleString('es-ES')
          }));
        },
        error: (error: any) => {
          console.error('Error', error);
        }});
    }


    this.defaultData.update(currentData => ({
      ...currentData,
      ...data
    }));
  }

  private handleAsotipChange() {
    this.defaultData.set(({
      ...this.form.value
    }));
  }

  private validateAutomaticDebitData(data: any): boolean {
    if (!('automaticDebit' in data)) {
      return false;
    }

    if (data.automaticDebit === false) {
      return true;
    }

    if (data.automaticDebit === true && data.debitType === 'INTERNO') {
      return true;
    }

    if (data.automaticDebit === true && data.debitType === 'EXTERNO') {
      return this.validateObjectAttributes(data, [
        'bank',
        'accountNumber',
        'accountType',
        'debitDay'
      ]);
    }

    return false;
  }

  private validateObjectAttributes(obj: any, keys: string[]): boolean {
    if (!obj) return false;

    for (const key of keys) {
      const value = obj[key];

      if (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '')
      ) {
        return false;
      }
    }

    return true;
  }

  validateAllData(): boolean {
    const currentData = this.defaultData();
    const currentAsotipId = this.asotipId();
    const isFormValid = this.form.valid;

    if (!isFormValid) {
      return false;
    }


    if (currentAsotipId == 1) {
      const independentValid = this.validateObjectAttributes(currentData, [
        'indact',
        'academic',
        'specialProtecionProgram',
        'econmicActivity',
        'income',
        'codpro',
      ]);
      if (!independentValid) return false;

      if (!currentData) return false;

      return this.validateAutomaticDebitData(currentData);
    }

    if (currentAsotipId == 2) {
      return this.validateObjectAttributes(currentData, [
        'since',
        'codpro',
        'academic',
        'company',
        'specialProtecionProgram',
        'income',
      ]);
    }

    if (currentAsotipId == 3) {
      return this.validateObjectAttributes(currentData, [
        'fonpen',
        'since',
        'codpro',
        'academic',
        'specialProtecionProgram',
        'income',
      ]);
    }

    if (currentAsotipId == 5) {
      return this.validateObjectAttributes(currentData, [
        'indact',
        'codpro',
        'academic',
        'specialProtecionProgram',
        'income',
      ]);
    }

    return true;
  }

  async onSubmit() {
    if (!this.isValidData()) {
      toast.error('Faltan datos por completar');
      return;
    }

    const normalized = collapseConsecutiveSpaces(this.form.get('address')?.value);
    this.patchAddressValue(normalized);

    if (!hasMinAddressLength(normalized)) {
      toast.error('Ingresa una dirección válida de al menos 8 caracteres.');
      return;
    }

    if (this.allowAddres) {
      this.saveData();
      return;
    }

    let response: any = null;
    if (this.lastProcessedAddress !== normalized || !this.lastAddressValidation) {
      this._loaderService.show();
      response = await this.normalizeAddressWithIA(normalized);
      this._loaderService.hide();
      if (!response || response.cleared || response.tooShort) {
        return;
      }
    }

    const validation = response?.result ?? this.lastAddressValidation;
    if (validation === 'INCORRECTA') {
      this.allowAddres = false;
      this.isValidAddress.set(true);
      return;
    }

    this.defaultData.update((currentData) => ({
      ...currentData,
      isAddressConfirmed: false
    }));
    this.saveData();
  }

  saveData() {
    this._loaderService.show();
    this._securityService.setAddressData(this.defaultData())
      .subscribe({
        next: (response: any) => {
          this.showWowSignal.set(true);
      },
      error: (err: any) => {
        this._loaderService.hide();
        this.isValidAddress.set(true);
      }
    });
  }

  hideWow(){
    this._loaderService.hide();
    localStorage.setItem('route', this.nextRoute());
    this.showWowSignal.set(false);
    this._router.navigateByUrl(this.nextRoute());
  }

  backValidateAddress(){
    this.isValidAddress.set(false);
    this.allowAddres = false;
    this.lastProcessedAddress = null;
    this.addressInput?.nativeElement?.focus();
    this.addressInput?.nativeElement?.select();
  }

  onCheckboxChange(event: any) {
    this.isChecked = event.target.checked;
  }

  validateAddress() {
    this._securityService.confirmAddress(true).subscribe({
      next: () => {
        this.defaultData.update((currentData) => ({
          ...currentData,
          isAddressConfirmed: true
        }));
        this.allowAddres = true;
        this.isChecked = false;
        this.isValidAddress.set(false);
        this.saveData();
      },
      error: () => {
        toast.error('No se pudo confirmar la dirección. Intenta de nuevo.');
      }
    });
  }

  failMessage(description:string, title:string = 'Error') {
    this.titleError = title;
    this.descriptionError = description;
    this.showError.set(true);
    this._loaderService.hide();
    localStorage.setItem('route', '/app/basic');
    this._router.navigateByUrl('/app/basic');
  }

  closeScreenError(){
    this.showError.set(false);
    this._router.navigateByUrl('/app/basic');
  }
}
